import { Splide } from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

export function slide() {
    window.addEventListener('DOMContentLoaded', function () {

        const splideElements = document.getElementsByClassName('splide');

        for (let i = 0; i < splideElements.length; i++) {
            new Splide(splideElements[i]).mount();
        }
        //FVの流れるテキスト
        if (document.querySelector(".js-slide-text--mv")) {
            const slideTextMv = new Splide(".js-slide-text--mv", {
                fixedWidth: '116.375rem',
                gap: 40,
                type: "loop",
                focus: 0,
                pagination: false,
                arrows: false,
                breakpoints: {
                    1024: {
                        fixedWidth: '93.125rem',
                        gap: 40,
                    },
                },
                autoScroll: {
                    speed: .5,
                    pauseOnHover: false,
                    pauseOnTouch: false,
                },
            });
            slideTextMv.mount({ AutoScroll });
        }
        // FVの流れる人物画像
        if (document.querySelector(".js-slide-img--mv")) {
            var list = document.querySelector('.js-slide-img--mv .splide__list');
            var items = Array.from(list.children);

            // スライドをランダムにシャッフル
            for (var i = items.length - 1; i > 0; i--) {
                var j = Math.floor(Math.random() * (i + 1));
                [items[i], items[j]] = [items[j], items[i]];
            }

            // フェードイン効果を追加
            items.forEach(function(item, index) {
                var delay = Math.random() * 1; // ランダムな遅延時間（0〜4秒）
                item.style.animationDelay = `${delay}s`;
                item.classList.add('fade-in');
                list.appendChild(item);
            });

            const slideImgMv = new Splide(".js-slide-img--mv", {
                fixedWidth: '26.6875rem',
                type: "loop",
                focus: 0,
                pagination: false,
                arrows: false,
                direction: 'rtl',
                breakpoints: {
                    768: {
                        fixedWidth: '23.4375rem',
                    },
                },
                autoScroll: {
                    speed: 0.5,
                    pauseOnHover: false,
                    pauseOnTouch: false,
                },
            });

            slideImgMv.mount({ AutoScroll });
        }

        // FVの流れる背景
        if (document.querySelector(".js-slide-bg--mv")) {
            var listBg = document.querySelector('.js-slide-bg--mv .splide__list');
            var itemsBg = Array.from(listBg.children);

            // フェードイン効果を追加（並べ替えはしない）
            itemsBg.forEach(function(item, index) {
                var delay = Math.random() * 1; // ランダムな遅延時間（0〜1.5秒）
                item.style.animationDelay = `${delay}s`;
                item.classList.add('fade-in');
            });

            const slideBgMv = new Splide(".js-slide-bg--mv", {
                fixedWidth: '26.6875rem',
                type: "loop",
                focus: 0,
                pagination: false,
                arrows: false,
                direction: 'rtl',
                breakpoints: {
                    768: {
                        fixedWidth: '23.4375rem',
                    },
                },
                autoScroll: {
                    speed: 0.5,
                    pauseOnHover: false,
                    pauseOnTouch: false,
                },
            });

            slideBgMv.mount({ AutoScroll });
        }


        // トップページセクション間の流れるテキスト
        if (document.querySelector(".js-slide-text--content")) {
            const slideTextContent = new Splide(".js-slide-text--content", {
                fixedWidth: '116.375rem',
                gap: 40,
                type: "loop",
                focus: 0,
                pagination: false,
                arrows: false,
                breakpoints: {
                    1024: {
                        fixedWidth: '93.125rem',
                        gap: 40,
                    },
                },
                autoScroll: {
                    speed: 0.5,
                    pauseOnHover: false,
                    pauseOnTouch: false,
                },
            });
            slideTextContent.mount({ AutoScroll });
        }

        // トップページセクション間の流れる人物画像
        if (document.querySelector(".js-slide-img--content")) {
            const slideImgContent = new Splide(".js-slide-img--content", {
                fixedWidth: '26.6875rem',
                type: "loop",
                focus: 0,
                pagination: false,
                arrows: false,
                direction: 'rtl',
                breakpoints: {
                    768: {
                        fixedWidth: '23.4375rem',
                    },
                },
                autoScroll: {
                    speed: 0.5,
                    pauseOnHover: false,
                    pauseOnTouch: false,
                },
            });
            slideImgContent.mount({ AutoScroll });
        }

        // トップページセクション間の流れる背景
        if (document.querySelector(".js-slide-bg--content")) {
            const slideBgContent = new Splide(".js-slide-bg--content", {
                fixedWidth: '26.6875rem',
                type: "loop",
                focus: 0,
                pagination: false,
                arrows: false,
                direction: 'rtl',
                breakpoints: {
                    768: {
                        fixedWidth: '23.4375rem',
                    },
                },
                autoScroll: {
                    speed: 0.5,
                    pauseOnHover: false,
                    pauseOnTouch: false,
                },
            });
            slideBgContent.mount({ AutoScroll });
        }

        // jobページの流れるスライド
        if (document.querySelector(".js-slide-auto")) {
            new Splide(".js-slide-auto", {
              perPage: 3,
              type: "loop",
              focus: 0,
              pagination: false,
              arrows: false,
              fixedWidth: '25rem',
              breakpoints: {
                768: {
                    fixedWidth: '23.4375rem',
                },
            },
              autoScroll: {
                speed: 1,
              },
            }).mount({ AutoScroll });
          }
    });
}
